import StyleSheet from 'react-native-extended-stylesheet';

/** display:none doesn't work well with native, and native solution doesn't work well with web
 * https://stackoverflow.com/a/58099301  **/
export const style = StyleSheet.create({
  loadingNative: {
    height: 0,
    width: 0,
    opacity: 0,
  },
  loadingWeb: {
    display: 'none',
  },
});
